import React from 'react'

const AnnualReturns = () => {
  return (
    <div id="content">

    <section className="welcome padding-top-50 padding-bottom-50">
      <div className="container">

			<div className="heading blck text-center">
			<h3>Annual Returns</h3>
			<hr/>
			</div>
			<div className="col-md-4"></div>
		   <div className="col-md-4">
				<table className="table table-bordered table-hover table-striped annualth">
				<tbody>
			{/* <!--	<tr><h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Financial Year</h3></tr>
				<tr><th>2008-09</th><th>2009-10</th>--> */}

        <tr><th><a href="assets/investor_relation/annual-returns/annual-returns-2025-2026.pdf" target="_blank">2025-26</a></th></tr>
        <tr><th><a href="assets/investor_relation/annual-returns/annual-returns-2024-2025.pdf" target="_blank">2024-25</a></th></tr>
        <tr><th><a href="assets/investor_relation/annual-returns/annual-returns-2023-2024.pdf" target="_blank">2023-24</a></th></tr>
        <tr><th><a href="assets/investor_relation/annual-returns/annual-returns-2022-2023.pdf" target="_blank">2022-23</a></th></tr>
        <tr><th><a href="assets/investor_relation/annual-returns/annual-returns-2021-2022.pdf" target="_blank">2021-22</a></th></tr>
				<tr><th><a href="assets/investor_relation/annual-returns/annual-returns-2020-2021.pdf" target="_blank">2020-21</a></th></tr>

				</tbody>
				</table>
         </div>
         <div className="col-md-4"></div>

           </div>

    </section>

  </div>
  )
}

export default AnnualReturns
